<template>
  <div>
    <title-bar :title-stack="titleStack" />
    <hero-bar>
      Page Not Found
    </hero-bar>

    <section class="section is-main-section">
      <div class="section container has-text-centered">
        <div class="columns is-centered">
          <div class="column is-two-fifths">
            <div>
              <div class="error-page-caption">
                <h2>404 page not found</h2>
              </div>
              <div class="error-page-caption">
                <a @click="goBack()" class="button is-primary">
                  Go Back
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import TitleBar from "@/components/TitleBar";
import HeroBar from "@/components/HeroBar";

export default {
  name: "NotFound",
  components: { HeroBar, TitleBar },
  computed: {
    titleStack() {
      return [{ url: "/", name: "Dashboard" }];
      //return ["Country Assignment"];
    }
  },
  data() {
    return {
      isModalActive: false
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<!-- <script>
export default {
  name: 'NotFound',
  
}
</script> -->
